import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getAllRows } from "../ReportElementHelper";

class VinSummary extends Component {
  state = {
    rows: [],
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  loadData = (props) => {
    const rows = [];
    if (props.record !== undefined) {
      _.forEach(
        _.get(props.record, "edmunds[0].vinDetails"),
        (record, index) => {
          const innerRows = [];
          _.forEach(_.get(props.record, "engine"), (engine) => {
            const recs = [];
            getAllRows(engine, recs, props, _.get(record, "$.display"));
            if (recs.length > 0) {
              innerRows.push(
                <Table.Row key={`engine_row_${index}`}>
                  <Table.Cell>
                    <Table>
                      <Table.Body>{recs}</Table.Body>
                    </Table>
                  </Table.Cell>
                </Table.Row>
              );
            }
          });
          _.forEach(_.get(props.record, "price"), (price) => {
            const recs = [];
            getAllRows(price, recs, props, _.get(record, "$.display"));
            if (recs.length > 0) {
              innerRows.push(
                <Table.Row key={`price_row_${index}`}>
                  <Table.Cell>
                    <Table>
                      <Table.Body>{recs}</Table.Body>
                    </Table>
                  </Table.Cell>
                </Table.Row>
              );
            }
          });

          const innerL2Rows = [];
          _.forEach(_.get(props.record, "transmission"), (transmission) => {
            const recs = [];
            getAllRows(transmission, recs, props, _.get(record, "$.display"));
            if (recs.length > 0) {
              innerL2Rows.push(
                <Table.Row key={`transmission_row_${index}`}>
                  <Table.Cell>
                    <Table>
                      <Table.Body>{recs}</Table.Body>
                    </Table>
                  </Table.Cell>
                </Table.Row>
              );
            }
          });
          _.forEach(_.get(props.record, "categories"), (categories) => {
            const recs = [];
            getAllRows(categories, recs, props, _.get(record, "$.display"));
            if (recs.length > 0) {
              innerL2Rows.push(
                <Table.Row key={`categories_row_${index}`}>
                  <Table.Cell>
                    <Table>
                      <Table.Body>{recs}</Table.Body>
                    </Table>
                  </Table.Cell>
                </Table.Row>
              );
            }
          });
          _.forEach(_.get(props.record, "MPG"), (MPG) => {
            const recs = [];
            getAllRows(MPG, recs, props, _.get(record, "$.display"));
            if (recs.length > 0) {
              innerL2Rows.push(
                <Table.Row key={`MPG_row_${index}`}>
                  <Table.Cell>
                    <Table>
                      <Table.Body>{recs}</Table.Body>
                    </Table>
                  </Table.Cell>
                </Table.Row>
              );
            }
          });
          rows.push(
            <Table key={`vin_summ_row_${index}`}>
              <Table.Body>
                <Table.Row key={`vin_summ_title_row_${index}`}>
                  <Table.HeaderCell colSpan={100}>VIN Details</Table.HeaderCell>
                </Table.Row>
                {innerRows.length > 0 && (
                  <Table key={`vin_summ_inner_first_row_${index}`}>
                    <Table.Body>{innerRows}</Table.Body>
                  </Table>
                )}
                {innerL2Rows.length > 0 && (
                  <Table key={`vin_summ_inner_second_row_${index}`}>
                    <Table.Body>{innerL2Rows}</Table.Body>
                  </Table>
                )}
              </Table.Body>
            </Table>
          );
        }
      );
    }
    this.setState({ rows });
  };
  render() {
    return (
      <Table>
        <Table.Body>
          <Table.Row key={`vin_summary_title_row`}>
            <Table.HeaderCell
              colSpan={100}
              className="report-sub-section-header text-center"
            >
              VIN Summary Details
            </Table.HeaderCell>
          </Table.Row>
          {this.state.rows}
        </Table.Body>
      </Table>
    );
  }
}

export default VinSummary;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/VinSummary.js